/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Intercultural_Competence23Inputs */

const en_job_form_enum_intercultural_competence23 = /** @type {(inputs: Job_Form_Enum_Intercultural_Competence23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intercultural Competence`)
};

const de_job_form_enum_intercultural_competence23 = /** @type {(inputs: Job_Form_Enum_Intercultural_Competence23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interkulturelle Kompetenz`)
};

/**
* | output |
* | --- |
* | "Intercultural Competence" |
*
* @param {Job_Form_Enum_Intercultural_Competence23Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_intercultural_competence23 = /** @type {((inputs?: Job_Form_Enum_Intercultural_Competence23Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Intercultural_Competence23Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_intercultural_competence23(inputs)
	return en_job_form_enum_intercultural_competence23(inputs)
});
export { job_form_enum_intercultural_competence23 as "job_form_enum_INTERCULTURAL_COMPETENCE" }